import { render } from "./Asset_Sales.vue?vue&type=template&id=486360cd&scoped=true"
import script from "./Asset_Sales.vue?vue&type=script&lang=js"
export * from "./Asset_Sales.vue?vue&type=script&lang=js"

import "./Asset_Sales.vue?vue&type=style&index=0&id=486360cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486360cd"]])

export default __exports__